import { render } from "./TypingCarousel.vue?vue&type=template&id=6d5d6927&ts=true"
import script from "./TypingCarousel.vue?vue&type=script&lang=ts"
export * from "./TypingCarousel.vue?vue&type=script&lang=ts"

import "./TypingCarousel.vue?vue&type=style&index=0&id=6d5d6927&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__